module.exports = __webpack_public_path__ + "img/user.b1c64d48.png";